// function for discount widget
function discount_widget() {
  	$('#horiz_bar').stop();
  	$('#horiz_bar').slideDown('fast',function() {
      	
      	$("#the_text").fitText(0.3, { minFontSize: '10px', maxFontSize: '200px' });
    	$("#the_code").fitText(1.1, { minFontSize: '10px', maxFontSize: '95px' });
      	discount_display();
    });
  	
}
function discount_hide() {
	if(!$('#horiz_bar').css('display') !== 'none') {
      $('#horiz_bar').slideUp('fast',function() {
        $('#horiz_bar').stop();
      });
    }
}
function reset_visits() {
  if(typeof(Storage)!=="undefined") {
  	localStorage.visits = 1;
    localStorage.ignore = 0;
  }
}
function inc_visits() {
  if(typeof(Storage)!=="undefined") {
    localStorage.visits = Number(localStorage.visits)+1;
  }
}
function discount_ignore() {
  if(typeof(Storage)!=="undefined") {
    localStorage.ignore = 1;
  }
}
function discount_display() {
	setTimeout(function() {
      discount_hide();
    }, 5000);
}
$(document).ready(function(){
  $(".state-btn").on("click",function(e){
    
    if($(".state-btn.active").length > 0){
      $(".state-btn.active").toggleClass("active");
    }
    
    $(this).addClass("active");
    
    if($(".state-content.show").length > 0){
      $(".state-content.show").toggleClass("show");
    }
    
    var state = $(this).data("state");
    
    $(".state-content[data-state='"+state+"']").addClass("show");
  });
    /* ajax add to cart */

    function addItem(form_id) {
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data: $('#'+form_id).serialize(),
      });
    }
	
  
  /* fittext */
  $("#the_text").fitText(0.3, { minFontSize: '10px', maxFontSize: '200px' });
  $("#the_code").fitText(1.1, { minFontSize: '10px', maxFontSize: '95px' });
  /* click action for discount */
  $('#horiz_bar_tab #target').click(function(){ 
     discount_widget();
     reset_visits();
     discount_display();
  });
  /* onload timing for discount widget */
  
  if(typeof(Storage)!=="undefined") {
    if(localStorage.ignore !== '1') {
      discount_widget();
      discount_display();
    }
  } else {
    discount_widget();
    discount_display();
  }
  $('#horiz_bar #ex').click(function() {
    /* set local storage for first visit */
    discount_hide();
    if(typeof(Storage)!=="undefined") {
      // Yes! localStorage and sessionStorage support!
      // Some code.....
      if(localStorage.visits) {
        inc_visits();
        discount_ignore();
        //alert('exists and is equal to '+localStorage.visits);
      }else{	
        reset_visits();
        discount_ignore();
        //alert('Now Created and is equal to '+localStorage.visits);
      }
    } else{
      // Sorry! No web storage support..
    }
  });
  /* add to cart animation */
   $(".addtocart").click(function(e){
   
      var elem = $(this)
      $(elem).prop("disabled", true)

      e.preventDefault();
      //addItem('add-item-form');
     
      var quantity = parseInt(jQuery('[name="quantity"]').val(), 10) || 1;

      function animate() {

        //$("#cart-animation").show();

        var addtocartWidth = elem.outerWidth() / 2
        var addtocartHeight = elem.outerHeight() / 2

        var addtocartLeft = elem.offset().left + addtocartWidth;
        var addtocartTop = $(elem).offset().top + addtocartHeight ;

        var buttonAreaWidth = $("#cart-target").outerWidth();
        var buttonAreaHeight = $("#cart-target").outerHeight();

        var buttonAreaLeft = ($("#cart-target").offset().left + buttonAreaWidth / 2  - $("#cart-animation").outerWidth() / 2) - 4;
        var buttonAreaTop = ($("#cart-target").offset().top + buttonAreaWidth / 2  - $("#cart-animation").outerHeight() / 2) - 4 ;

        var path = {
          start: {
            x: addtocartLeft,
            y: addtocartTop,
            angle: 190.012,
            length: 0.2
          },
          end: {
            x: buttonAreaLeft,
            y: buttonAreaTop,
            angle: 90.012,
            length: 0.50
          }
        };
   
        $('#cart-animation').text(quantity).animate(
        {
          path : new $.path.bezier(path)
        },
        100,
        function() {
          $("#cart-animation").fadeOut(100, function() {
            $(elem).prop("disabled", false);
            var cartCount =  parseInt($('#cart-count').text()) + quantity;
            $('span#cart-count').text(cartCount);
            $('#checkout-link').addClass('display');
          })
        }
        );
      }
   
      animate();
     
    }) 
  /* end animation */

})



jQuery(window).load(function(){



  if ( $('.slides li').size() > 1 ) {

    $('.other_flexslider').flexslider({
      animation: "slide",
      slideshow: false,
      animationDuration: 700,
      animation: "fade",
      controlsContainer: ".flex-controls",
      keyboardNav: true
    });
	
    $('.home_flexslider').flexslider({
      animation: "slide",
      slideshow: true,
      animationDuration: 700,
      slideshowSpeed: 6000,
      animation: "fade",
      controlsContainer: ".flex-controls",
      keyboardNav: true
    });
  }

  $("select.loc_on_change").change(function(){
  	if($(this).attr("value") == "#") return false;
  	window.location = $(this).attr("value");
  });

  
});

jQuery(document).ready(function($){
  
  $(".tweet").tweet({ // twitter plugin
    username: "",
    join_text: "auto",
    avatar_size: 32,
    count: 2,
    auto_join_text_default: "", 
    auto_join_text_ed: "",
    auto_join_text_ing: "",
    auto_join_text_reply: "",
    auto_join_text_url: "",
    loading_text: "Loading Tweets..."
  });
  	
  $("a.zoom").fancybox({
    padding:0,
    'titleShow': false,
    overlayColor: '#000000',
    overlayOpacity: 0.2
  });

  $("nav.mobile select").change(function(){ window.location = jQuery(this).val(); });
  $('#product .thumbs a').click(function(){
    
    $('#placeholder').attr('href', $(this).attr('href'));
    $('#placeholder img').attr('src', $(this).attr('data-original-image'))
    
    $('#zoom-image').attr('href', $(this).attr('href'));
    return false;
  });
  

  
  $('input[type="submit"], input.btn, button').click(function(){ // remove ugly outline on input button click
    $(this).blur();
  })
  
  $("li.dropdown").hover(function(){
    $(this).children('.dropdown').show();
    $(this).children('.dropdown').stop();
    $(this).children('.dropdown').animate({
      opacity: 1.0
    }, 200);
  }, function(){
    $(this).children('.dropdown').stop();
    $(this).children('.dropdown').animate({
      opacity: 0.0
    }, 400, function(){
      $(this).hide();
    });
  });
  
  $('a[href^="#"]').bind('click.smoothscroll',function (e) {

    e.preventDefault();
    
    var target = this.hash,
        $target = $(target);
    
    $('html, body').stop().animate({
        'scrollTop': $target.offset().top
    }, 500, 'swing', function () {
        window.location.hash = target;
    });
  });
  
  var tabs = $('ul.tabs > li > a');
  tabs.each(function(i) {
    jQuery(this).unbind('click.smoothscroll')
    .click(function(e) {
         var contentLocation = $(this).attr('href');
    	 if(contentLocation.charAt(0)=="#") {            
  		tabs.removeClass('active');
  		$(this).addClass('active');
  		$(contentLocation).show().addClass('active').siblings().hide().removeClass('active');
    	 }
      return false;
    });
  });


  
}); // end document ready

/* jQuery css bezier animation support -- Jonah Fox */
 
;(function($){
 
  $.path = {};
 
  var V = {
    rotate: function(p, degrees) {
      var radians = degrees * Math.PI / 180,
        c = Math.cos(radians),
        s = Math.sin(radians);
      return [c*p[0] - s*p[1], s*p[0] + c*p[1]];
    },
    scale: function(p, n) {
      return [n*p[0], n*p[1]];
    },
    add: function(a, b) {
      return [a[0]+b[0], a[1]+b[1]];
    },
    minus: function(a, b) {
      return [a[0]-b[0], a[1]-b[1]];
    }
  };
 
  $.path.bezier = function( params, rotate ) {
    params.start = $.extend( {angle: 0, length: 0.3333}, params.start );
    params.end = $.extend( {angle: 0, length: 0.3333}, params.end );
 
    this.p1 = [params.start.x, params.start.y];
    this.p4 = [params.end.x, params.end.y];
 
    var v14 = V.minus( this.p4, this.p1 ),
      v12 = V.scale( v14, params.start.length ),
      v41 = V.scale( v14, -1 ),
      v43 = V.scale( v41, params.end.length );
 
    v12 = V.rotate( v12, params.start.angle );
    this.p2 = V.add( this.p1, v12 );
 
    v43 = V.rotate(v43, params.end.angle );
    this.p3 = V.add( this.p4, v43 );
 
    this.f1 = function(t) { return (t*t*t); };
    this.f2 = function(t) { return (3*t*t*(1-t)); };
    this.f3 = function(t) { return (3*t*(1-t)*(1-t)); };
    this.f4 = function(t) { return ((1-t)*(1-t)*(1-t)); };
 
    /* p from 0 to 1 */
    this.css = function(p) {
      var f1 = this.f1(p), f2 = this.f2(p), f3 = this.f3(p), f4=this.f4(p), css = {};
      if (rotate) {
        css.prevX = this.x;
        css.prevY = this.y;
      }
      css.x = this.x = ( this.p1[0]*f1 + this.p2[0]*f2 +this.p3[0]*f3 + this.p4[0]*f4 +.5 )|0;
      css.y = this.y = ( this.p1[1]*f1 + this.p2[1]*f2 +this.p3[1]*f3 + this.p4[1]*f4 +.5 )|0;
      css.left = css.x + "px";
      css.top = css.y + "px";
      return css;
    };
  };
 
  $.path.arc = function(params, rotate) {
    for ( var i in params ) {
      this[i] = params[i];
    }
 
    this.dir = this.dir || 1;
 
    while ( this.start > this.end && this.dir > 0 ) {
      this.start -= 360;
    }
 
    while ( this.start < this.end && this.dir < 0 ) {
      this.start += 360;
    }
 
    this.css = function(p) {
      var a = ( this.start * (p ) + this.end * (1-(p )) ) * Math.PI / 180,
        css = {};
 
      if (rotate) {
        css.prevX = this.x;
        css.prevY = this.y;
      }
      css.x = this.x = ( Math.sin(a) * this.radius + this.center[0] +.5 )|0;
      css.y = this.y = ( Math.cos(a) * this.radius + this.center[1] +.5 )|0;
      css.left = css.x + "px";
      css.top = css.y + "px";
      return css;
    };
  };
 
  $.fx.step.path = function(fx) {
    var css = fx.end.css( 1 - fx.pos );
    if ( css.prevX != null ) {
      $.cssHooks.transform.set( fx.elem, "rotate(" + Math.atan2(css.prevY - css.y, css.prevX - css.x) + ")" );
    }
    fx.elem.style.top = css.top;
    fx.elem.style.left = css.left;
  };
 
})(jQuery);
